import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=1a8ce7a7&"
import script from "./CurrentUser.vue?vue&type=script&lang=ts&"
export * from "./CurrentUser.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports